import CompanyContractTypeModal from "../company-contract-type/modals/CompanyContractTypeModal.vue";

Vue.component('company-contract-type-modal', CompanyContractTypeModal);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/company-contract-type/index.js